import { Router } from '@angular/router';
import { SocketService } from './../../shared/services/socket.service';
import { Component, OnDestroy, Inject, OnInit, ViewChild } from '@angular/core';
import { DOCUMENT } from '@angular/common';

import { MenuService, NavData } from '../../core/menu/menu.service';
import { AuthService } from '../../shared/services/auth.service';
import { User } from '../../shared/models/user.model';

import { PagelaService } from '../../pages/teacher/teacher-pagela/shared/pagela.service';
import { ModalAddAvatarComponent } from '../../shared/components/modals/modal-add-avatar/modal-add-avatar.component';

import { BsModalRef, ModalDirective } from 'ngx-bootstrap';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { MatDialog } from '@angular/material';



@Component({
  selector: 'app-teacher-layout',
  templateUrl: './teacher-layout.component.html',
  styleUrls: ['./teacher-layout.component.scss']
})
export class TeacherLayoutComponent implements OnInit, OnDestroy{

  @ViewChild('childModal') childModal: ModalDirective;
  public modalRef: BsModalRef;
  
  private changes: MutationObserver;
  public user: User;
  public navItems: Array<NavData>;
  public sidebarMinimized: boolean = true;
  public element: HTMLElement;
  
  public avatarImg: string;
  public idleState: string = 'Não iniciado.';
  public timedOut: boolean = false;
  public lastPing?: Date = null;
  public title: string = 'ICBEU Manaus';

  constructor(
    private pagelaService: PagelaService,
    private socketService: SocketService,
    private menuService: MenuService, 
    private authService: AuthService,
    private idle: Idle, 
    private keepalive: Keepalive,
    private router: Router,
    private dialog: MatDialog,
    @Inject(DOCUMENT) _document?: any,
  ) {
    this.changes = new MutationObserver((mutations) => {
      this.sidebarMinimized = _document.body.classList.contains('sidebar-minimized');
    });
    this.element = _document.body;
    this.changes.observe(<Element>this.element, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  ngOnInit(): void {  
    this.user = this.authService.getUser();
    this.establishSocketConnection();
    this.establishIdle();
    
    if(this.user.idTipoAcesso == 3){
      this.navItems  = this.menuService.getTeacherAll();
    }else if(this.user.idTipoAcesso == 5){
      this.navItems  = this.menuService.getManagerAll();
    }
           
    this.authService.getAvatar().subscribe(img => {
      this.avatarImg = img;
    });
    
  }

  public async establishSocketConnection() {
    try {      
      await this.socketService.connectSocket(
        this.authService.getUser().idCadsite, 
        this.authService.getUser().nome, 
        this.authService.getUser().idTipoAcesso
      );
    } catch (error) {
      console.error('Error to connect socket server')
    }
  }

  public establishIdle() {
    // sets an idle timeout of 5 seconds, for testing purposes.
    this.idle.setIdle(1800);
    // sets a timeout period of 5 seconds. after 10 seconds of inactivity, the user will be considered timed out.
    this.idle.setTimeout(60);
    // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    this.idle.onIdleEnd.subscribe(() => { 
      this.idleState = 'Usuário não mais ocioso.'
      console.log(this.idleState);
      this.reset();
    });
    
    this.idle.onTimeout.subscribe(() => {
      this.childModal.hide();
      this.idleState = 'Tempo esgotado!';
      this.timedOut = true;
      console.log(this.idleState);
      this.logout();
      this.router.navigate(['/login']);
    });
    
    this.idle.onIdleStart.subscribe(() => {
        this.idleState = 'Você ficou ocioso!'
        console.log(this.idleState);
        this.childModal.show();
    });
    
    this.idle.onTimeoutWarning.subscribe((countdown) => {
      this.idleState = 'Você será deslogado em ' + countdown + ' segundos!'
      console.log(this.idleState);
    });

    // sets the ping interval to 15 seconds
    this.keepalive.interval(15);
    this.keepalive.onPing.subscribe(() => this.lastPing = new Date());

    const userLoggedInoggedIn: boolean = this.authService.getUserLoggedIn()                
    if (userLoggedInoggedIn) {
      this.idle.watch()
      this.timedOut = false;
    } else {
      this.idle.stop();
    }
    
  }

  public openDialogAvatar() {
    this.dialog.open(ModalAddAvatarComponent);
  }

  public logout(): void {
    this.pagelaService.events = [];
    this.socketService.logout(
      this.authService.getUser().idCadsite, 
      this.authService.getUser().nome, 
      this.authService.getUser().idTipoAcesso
    );
    this.authService.logout();
  }

  ngOnDestroy(): void {
    this.changes.disconnect();
  }

  public reset() {
    this.idle.watch();
    //this.idleState = 'Started.';
    this.timedOut = false;
  }

  public hideChildModal(): void {
    this.childModal.hide();
  }

  public stay() {
    this.childModal.hide();
    this.reset();
  }
}
